<template>
  <a
    @click="selectDate"
    :class="{
      disabled: disabled,
      placeholder: date === undefined || day === '',
      selected: $store.state.selectedDate === date,
    }"
  >
    <span>{{ day }}</span>
  </a>
</template>

<script>
import axios from "axios";
export default {
  name: "Day",
  props: {
    date: String,
    day: String,
    disabled: Boolean,
  },
  methods: {
    selectDate() {
      this.$store.commit("setSelectedBooking", '');
      this.$store.commit("setSelectedDate", this.date);
      const params = new URLSearchParams();
      params.append("date", this.date);
      params.append("schedule", this.$store.state.selectedSchedule);
      axios
        .post(`${this.$store.state.API}/Bookings.php`, params)
        .then(this.onGetBookings);
    },    
    scrollToHash(){
      const element = document.querySelector('#available-times');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    onGetBookings(response) {
      if (response.data.status == "ok") {
          this.$store.commit("setAvailableBookings", response.data['json-content']);   
          setTimeout(this.scrollToHash, 1)
      } else {
        this.$store.commit("setSelectedDate", "");
        alert("An error occurred getting the bookings");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  display: grid;
  place-items: center;  
  box-sizing: border-box;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  font-family: inherit;
  font-weight: 300;
  font-size: 22px;
  width: 100%;
      height: 100%;
  @media (min-width:400px) {
    width: 40px;
    height: 40px;
  }
  &.selected span {
    background: linear-gradient(180deg, #4B92DB 0%, #4B92DB 100%);
    color: var(--white);
  }
  @media (hover: hover) {
    &:hover {
      span {
        background: var(--blue);
      }
    }
  }
  span {
    transition: 0.2s all ease-in-out;
    
    display: grid;
    place-items: center;        
    color: var(--white);
    border-radius: 2px;
    border: 1px solid #A5ACAF33;
    background: linear-gradient(97.41deg, rgba(217, 217, 217, 0.06) 5.18%, rgba(217, 217, 217, 0.02) 48.5%, rgba(217, 217, 217, 0.06) 93.67%);
    font-weight: 300;
    width: 100%;
      height: 100%;
    @media (min-width:400px) {
     width: 40px;
      height: 40px;
    }
  }
}
a:not(.disabled) span {
  border: 1px solid #A5ACAF33;
}
.placeholder {
  opacity: 0;
  pointer-events: none;
}
.disabled {  
  pointer-events: none;
  span {
   opacity: 0.2;
   border-radius: 2px;
background: rgba(0, 0, 0, 1);
  }
}
</style>